import { filter, take } from 'rxjs/operators';
import { ApplicationRef, inject, Injectable } from '@angular/core';
import { Socket } from 'ngx-socket-io';

import { environment } from '../environments/environment';
import { AuthSyncService } from '../app/auth-sync.service';

@Injectable()
export class OrgSocket extends Socket {
  constructor(readonly authSyncService: AuthSyncService) {
    super(
      {
        url: `${environment.BASE_PATH}/org`,
        options: {
          autoConnect: false,
          transports: ['websocket'],
        },
      },
      inject(ApplicationRef)
    );
    this.authSyncService.$user
      .pipe(
        filter(user => !!user),
        take(1)
      )
      .subscribe(user => {
        this.connectSocketWithAuth(this.authSyncService.getToken());
      });
  }
  private connectSocketWithAuth(token: string) {
    this.ioSocket.io.opts.query = {
      token,
    };
    this.connect();
  }
}
